module.exports = __webpack_public_path__ + "assets/avatar-login.63a31eb5.svg";